import { Option } from '@/components/Form';
import { rwColors } from '@/styles/colors';
import tailwindConfig from '@@/tailwind.config';
import { StylesConfig } from 'react-select';
import resolveConfig from 'tailwindcss/resolveConfig';
import { Z_INDEX } from '../constants';
import { MenuPositioning } from '../hooks/useMenuPositioning';

const fullConfig = resolveConfig(tailwindConfig);
const fontSizes = fullConfig.theme.fontSize;

export const buildFacetSelectFieldStyles = (
  labelColor: string,
  menuPositioning?: MenuPositioning
): StylesConfig<Option, true> => {
  return {
    dropdownIndicator: () => ({
      display: 'none',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    control: (provided) => ({
      ...provided,
      boxShadow: 'none',
      border: 'none',
      backgroundColor: 'transparent',
      '&:hover': { borderColor: labelColor },
    }),
    option: (provided, { isFocused }) => ({
      ...provided,
      fontSize: fontSizes.sm[0],
      color: isFocused ? 'white' : provided.color,
      backgroundColor: isFocused ? rwColors.main : provided.backgroundColor,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: rwColors.main,
      color: 'white',
    }),
    multiValueLabel: (provided) => ({ ...provided, color: 'white' }),
    multiValueRemove: (provided) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': { backgroundColor: 'transparent' },
      '> svg': {
        width: '10px',
        height: '10px',
        backgroundColor: 'white',
        borderRadius: '50%',
        color: rwColors.main,
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      paddingLeft: '55px',
    }),
    input: (provided) => ({
      ...provided,
      marginLeft: 0,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: rwColors.gray,
      marginLeft: 0,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: Z_INDEX.FACET_SELECT_MENU_PORTAL,
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: menuPositioning?.maxHeight || 300,
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: menuPositioning?.maxHeight || 300,
    }),
  };
};
